import HomePage from './HomePage';
import { BrowserRouter, Route, Routes } from 'react-router';
import ContactUs from './Pages/ContactUs';
import MissionStatement from './Pages/MissionStatement';
import Industry from './Pages/Industry';
import CareerOpportunities from './Pages/CareerOpportunities';
import STEM from './Pages/STEM';
import OurApproach from './Pages/OurApproach';
import ProvenAndEvolving from './Pages/ProvenAndEvolving';
import { ChatboxWrapper } from './Chatbot/ChatboxWrapper';

export default function App() {
  return (
    <>
      <ChatboxWrapper />
      <BrowserRouter>
        <Routes>
          <Route index element={<HomePage />} />
          <Route path='/contact' element={<ContactUs />} />
          <Route path='/missionstatement' element={<MissionStatement />} />
          <Route path='/industry' element={<Industry />} />
          <Route path='/careeropportunities' element={<CareerOpportunities />} />
          <Route path='/stem' element={<STEM />} />
          <Route path='/ourapproach' element={<OurApproach />} />
          <Route path='/provenandevolving' element={<ProvenAndEvolving />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}
